import { render, staticRenderFns } from "./Customstyles.vue?vue&type=template&id=68233b35&scoped=true"
import script from "./Customstyles.vue?vue&type=script&lang=js"
export * from "./Customstyles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68233b35",
  null
  
)

export default component.exports